<div class="listBox row">
  @if (showfilter) {
    <input (keyup)="onKeydownEvent()" [(ngModel)]="filterFor" placeholder="Type to Filter"/>
  }
  <div class="text row">
    @if (previewItems.length <= 0) {
      <div class="listText">
        <span class="preview-name preview-placeholder no-items-preview">no items to display...</span>
      </div>
    }
    @for (item of previewItems; track item) {
      <div (click)="selected(item)" [ngClass]="{ clickable: clickable }" class="listText">
        @if (allowRemove) {
          <div class="icon-clear" (click)="remove(item)"></div>
        }
        @if (!item.href) {
          <span class="preview-name" matTooltip="{{tooltip}}" matTooltipPosition="below" matTooltipShowDelay="1000">{{ item.name || item }}</span>
        }
        @if (item.href) {
          <a [href]="getHrefVal(item.href)" (click)="linkClicked($event, item)" class="{{item.linkClass ? item.linkClass : ''}}" matTooltip="{{tooltip}}" matTooltipShowDelay="1000" matTooltipPosition="below">
            @if (item.name) {
              <span class="preview-name">{{ item.name }}@if (item.iconClass) {
                <div class="preview-item-icon {{item.iconClass}}" (click)="remove(item)"></div>
              }</span>
            }
          </a>
        }
      </div>
    }
  </div>
</div>
@if (isLoading) {
  <div class="spinner-container">
    <span class="spinner"></span>
  </div>
}
